const READ_KEY = `6f222218512b35ef69a2ac84fee42e365727a272ce27ceb35be64e24a24f3ba6`;
const WRITE_KEY = `fe3ffe1476c16a0edf7892595ab10592278017c8a6677aa334a55d2a995c1cee`;
const TOKEN_ID = `1`;
const API_URL = process.env
  ? process.env.REACT_APP_API_URL
  : `https://127.0.0.1/api`;

export { READ_KEY, WRITE_KEY, TOKEN_ID, API_URL };
